import range from 'lodash/range';

import type { Space } from './types';
import { generateSpacings } from './utils';

const legacySpace: Partial<Space> = {
  s000: '0',
  s025: '0.25rem',
  s035: '0.4375rem',
  s050: '0.5rem',
  s065: '0.5625rem',
  s070: '0.6875rem',
  s075: '0.75rem',
  s080: '0.875rem',
  s100: '1rem',
  s120: '1.1875rem',
  s125: '1.25rem',
  s150: '1.5rem',
  s175: '1.75rem',
  s200: '2rem',
  s250: '2.5rem',
  s300: '3rem',
  s350: '3.5rem',
  s400: '4rem',
  s500: '5rem',
  s600: '6rem',
  s800: '8rem',
  s1000: '10rem',
};

range(1, 20).forEach((i) => {
  legacySpace[i as keyof Space] = generateSpacings(i);
});

export const space = legacySpace as Space;
